<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
          <div class='sub-title-wrap-tab'>
            <ul>
              <li class='float-left sub-title'>{{tab.title}}</li>
            </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='work-order-grid'>
        <dx-data-grid ref='refWorkOrderGrid'
          :data-source='workOrderInfoList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          @focused-row-changed="onSelectionChanged"
          :auto-navigate-to-focused-row="false"
          key-expr="seqId"
          :focused-row-key.sync='focusedRowKey'
          @row-removed='onRowRemoved' @row-inserted='onRowInserted' @row-inserting='onRowInserting'
          @row-updated='onRowUpdated'
          @editor-preparing='onEditorPreparing'
          @init-new-row='onInitNewRow'
          @toolbar-preparing='onToolbarPreparing'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            :file-name="workOrderTitle"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxEditing
            :allow-deleting="true"
            :allow-updating="true"
            :allow-adding="true"
            :use-icons="true"
            mode='popup'
          >
            <DxPopup
              :show-title="true"
              :width="700"
              :height="260"
              title="품록등록"
            >
              <dx-position
                my="center"
                at="center"
                of="window"
              />
            </DxPopup>
            <DxForm>
                <DxItem
                :col-count="2"
                :col-span="2"
                item-type="group"
                >
                  <DxItem data-field="품명"/>
                  <DxItem data-field="생산시작시간"/>
                  <DxItem data-field="생산종료시간"/>
                  <DxItem data-field="수량" />
                  <DxItem data-field="라인명"/>
                </DxItem>
              </DxForm>
          </DxEditing>
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            width="90"
            :buttons="editButtons"
            type="buttons"
          />
          <DxColumn
            :allowEditing='false'
            :fixed="true"
            caption="작업번호"
            data-field="seqId"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="품목유형"
            data-field="품목유형"
            :visible='true'
            sort-order='asc'
          >
            <DxLookup
              :data-source="goodsLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='isIdEdit'
            :fixed="true"
            caption="품번"
            data-field="품번"
            sort-order='asc'
            edit-cell-template="productionGridTemplate"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            :fixed="true"
            caption="품명"
            data-field="품명"
            :visible='true'
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="시작시간"
            data-field="생산시작시간"
            dataType= 'datetime'
            format='yyyy-MM-dd HH:mm'
            width = '120'
            sort-order='asc'>
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="종료시간"
            data-field="생산종료시간"
            dataType= 'datetime'
            format='yyyy-MM-dd HH:mm'
            width = '120'>
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="생산계획"
            data-field="수량"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="라인명"
            data-field="라인코드"
            :visible='true'
            edit-cell-template="lineGridTemplate"
          >
            <DxLookup
              :data-source="lineList"
              display-expr="라인명"
              value-expr="라인코드"
            />
            <dx-required-rule message="항목을 선택하세요"/>
          </DxColumn>
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              column="seqId"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
          <template #lineGridTemplate="{ data: cellInfo }">
            <LineGridComponent
              :value="cellInfo.value"
              :on-value-changed="cellInfo.setValue"
              @selected-line='setLineCode'
              :lineInfo='lineList'
            />
          </template>
          <template #productionGridTemplate="{ data: cellInfo }">
            <ProductionGridComponent
              :value="cellInfo.value"
              :on-value-changed="cellInfo.setValue"
              @selected-pcode='setProductionCode'
              :productionInfo='productionList'
              :isEdit='isIdEdit'
            />
          </template>
        </dx-data-grid>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxForm, DxLookup,
  DxSummary, DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxPopup, DxPosition } from 'devextreme-vue/data-grid'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import { DxItem } from 'devextreme-vue/form'
import ProductionGridComponent from '../../share/component/ProductionGridComponent'
import LineGridComponent from '../../share/component/LineGridComponent'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '일일 작업지시'
        }
      ],
      editButtons: ['edit', 'delete'],
      workOrderTitle: null,
      orderDate: null,
      workOrderInfoList: null,
      focusedRowKey: null,
      isIdEdit: false,
      lineList: null,
      productionList: null,
      selectedLineCode: null,
      selectedProductionCode: null,
      selectedSabun: null,
      goodsLookup: null,
      // ****** 근무팝업 ******************
      popupShift: false
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumnFixing,
    DxTotalItem,
    DxForm,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    DxPopup,
    DxPosition,
    DxLookup,
    DxRequiredRule,
    DxItem,
    ProductionGridComponent,
    LineGridComponent
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.goodsLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.orderDate = AppLib.getToday()
    this.workOrderTitle = `${this.orderDate}-작업지시서`
    this.refreshWorkOrder(true) // true noRetry
    this.refreshLine()
    this.refreshProduction()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    createWorkOrder (date) {
      this.isLoading = true
      let param = {
        생산기준일: this.orderDate,
        createid: this.userInfo.userName
      }
      this.$_sp.runUpdateProc('spCreateWorkOrderByDate', [param])
        .then((data) => {
          this.isLoading = false
          this.refreshWorkOrder(false)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onEditorPreparing (e) {
      if (e.dataField === '수량' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
    },
    onInitNewRow (row) {
      const startTime = this.$_.findWhere(this.$store.getters.getSysParam, { key: '주간생산시작시간' }).value
      row.data.생산시작시간 = `${this.orderDate} ${startTime}`
      row.data.생산종료시간 = `${this.orderDate} 18:00`
      row.data.생산기준일 = this.orderDate
    },
    onRowInserted (row) {
      // row.data.품번 = this.selectedProductionCode
      // row.data.사번 = this.selectedSabun
      row.data.updatetime = row.data.createtime = AppLib.getNow()
      row.data.updateid = row.data.createid = this.userInfo.userName
      row.data.품목유형 = this.$_.findWhere(this.productionList, { 품번: row.data.품번 }).품목유형

      this.isLoading = true
      this.$_sp.runInsertAndFindSqlProc('작업지시', ['품번', 'createtime'], ['seqId', '품명', '라인명', '부서명', '품목유형', '근무형태'], row.data)
        .then((data) => {
          this.isLoading = false
          row.data.seqId = this.$_sp.MakeModel(data)[0].seqId
          this.$refs.refWorkOrderGrid.instance.refresh()
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowInserting (row) {

    },
    onRowRemoved (row) {
      this.isLoading = true
      this.$_sp.runDeleteSqlProc('작업지시', [{ seqId: row.data.seqId }])
        .then((data) => {
          this.isLoading = false
          this.$snotify.info('삭제 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdated (row) {
      this.isLoading = true
      row.data.updatetime = AppLib.getNow()
      row.data.updateid = this.userInfo.userName
      this.$_sp.runUpdateSqlProc('작업지시', ['seqId'], ['품명', '라인명', '부서명', '품목유형', '근무형태'], [row.data])
        .then((data) => {
          this.isLoading = false
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onSelectionChanged (e) {

    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>생산기준일 : </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 120,
            value: this.orderDate,
            type: 'date',
            displayFormat: 'yyyy-MM-dd',
            onValueChanged: (args) => {
              this.orderDate = args.value
              this.workOrderTitle = `${this.orderDate}-작업지시서`
              this.refreshWorkOrder(true)
            }
          }
        },
        {
          location: 'before',
          widget: 'dxButton',
          options: {
            hint: '새로고침',
            icon: 'refresh',
            text: '작업지시 재생성',
            type: 'default',
            focusStateEnabled: true,
            onClick: (args) => {
              this.$snotify.confirm(`현 작업지시서 삭제후 주간계획 기준으로 재 생성됩니다.`, '', {
                timeout: 10000,
                showProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                buttons: [
                  { text: '재생성',
                    action: (toast) => {
                      this.$snotify.remove(toast.id)
                      this.createWorkOrder(this.orderDate)
                    }
                  },
                  { text: '취소',
                    action: (toast) => { this.$snotify.remove(toast.id) }
                  }
                ]
              })
            }
          }
        }
      )
    },
    refreshProduction () {
      this.$_sp.runNoEncodeFindProc('spFindAllProduction', {})
        .then((data) => {
          this.productionList = this.$_sp.MakeModel(data)
          console.log(this.productionList)
        })
    },
    refreshLine () {
      this.$_sp.runNoEncodeFindSqlProc('생산라인', null)
        .then((data) => {
          this.lineList = this.$_sp.MakeModel(data)
        })
    },
    refreshWorkOrder (isNotRetry) {
      this.isLoading = true
      this.$_sp.runNoEncodeFindProc('spFindAllWorkOrderByDate', { 생산기준일: this.orderDate })
        .then((data) => {
          this.isLoading = false
          this.workOrderInfoList = this.$_sp.MakeModel(data)
          console.log(this.workOrderInfoList)
          if (!isNotRetry && this.workOrderInfoList.length === 0) {
            this.createWorkOrder(this.orderDate)
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // emit compnay search
    setLineCode (code) {
      this.selectedLineCode = code
    },
    setSabunCode (code) {
      this.selectedSabun = code
    },
    setProductionCode (code) {
      this.selectedProductionCode = code
    }
  }
}
</script>

<style lang="scss">

</style>
